// Designation.jsx
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import IcdqModal from "../../AppComponents/icdqmodal/icdqmodal";

const DocumentType = () => {

  const screenfields = [
    {
      caption: "Code",
      field: "code",
      type: "text",
      required: true,
      spacefield: 3
    },
    {
      caption: "Document Type",
      type: "text",
      field: "documenttype",
      spacefield: 2,
      required: true,
      fieldwidth: 6
    },
    {
      caption: "Description",
      type: "textarea",
      field: "description",
      spacefield: 2,
      required: true,
      fieldwidth: 6
    }
  ];
  const tableColumns = [
    { field: 'code', label: 'Code', width: 20 },
    { field: 'documenttype', label: 'Document Type', width: 30 },
    { field: 'description', label: 'Description', width: 200 },
  ];

  return (
    <IcdqModal GridWidth="70" FieldsArr={screenfields} title="Document Type" controller="documenttypes" GridColumns={tableColumns} PrimaryKeyField="id" />
  );
};

export default DocumentType;
